import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* College Info */}
        <div className="footer-col">
          <h2>MASTERS DEGREE & PG COLLEGE</h2>
         

          <p>📍 Sangareddy</p>
          
        <p> 📞Principal: +91 9705460212</p>
        <p> 📞Vice Principal: 9908238668</p>
        <p>📞Office: 9063020212</p>
        
            <p>
  <a href="mailto:principal@mastersdegreepgcollege.in">
    🌐principal@mastersdegreepgcollege.in
  </a>
</p>
        </div>

        {/* Quick Links */}
        <div className="footer-col">
          <h3>Quick Links</h3>
          <ul>
            <li>About Us</li>
            <li>Admissions</li>
            <li>Academics</li>
            <li>Contact Us</li>
          </ul>
        </div>

        {/* Academics */}
        <div className="footer-col">
          <h3>Academics</h3>
          <ul>
            <li>Degree Programs</li>
            <li>PG Programs</li>
          </ul>
        </div>

        {/* Resources */}
        <div className="footer-col">
          <h3>Resources</h3>
          <ul>
            <li>Academic Calendar</li>
          </ul>
        </div>

      </div>

      <div className="footer-bottom">
       

        © 2026 Masters Degree & PG College. All Rights Reserved.
      </div>
    </footer>
  );
}

export default Footer;